/**
 * org模块路由
 * Created by kb on 2017/09/04.
 */
import _import from './_import_development'

export  default {
  path: '/pay',
  name: 'pay',
  component: _import("Home"),
  meta: {permission: false},
  children: [
    { path: 'PaymentbankAdd',component:_import("pay/PaymentbankAdd"),name:'支付编辑页'},
    { path: 'PaymentbankInfo',component:_import("pay/PaymentbankInfo"),name:'支付详情页'},

    { path: 'pay-old',component:_import("pay/pay-old"),name:'支付页'},
    { path: 'pay',component:_import("pay/pay"),name:'支付页'},
    { path: 'pay2',component:_import("pay/pay2"),name:'支付页2'},
    { path: 'pay3',component:_import("pay/pay3"),name:'支付页3'},
    { path: 'pay4',component:_import("pay/pay4"),name:'支付页4'},
    { path: 'pay5',component:_import("pay/pay5"),name:'支付页5'},
    { path: 'pay6',component:_import("pay/pay6"),name:'支付页6'},
    { path: 'pay7',component:_import("pay/pay7"),name:'支付页7'},
    { path: 'PaySettingBank',component:_import("pay/PaySettingBank"),name:'维护银行信息'},
    { path: 'payQuickRemove',component:_import("pay/payQuickRemove"),name:'快捷支付解绑'},

    { path: 'payQuick',component:_import("pay/payQuick"),name:'快捷支付'},
    { path: 'payWechat',component:_import("pay/payWechat"),name:'微信支付'},

    { path: 'paySuccess',component:_import("pay/paySuccess"),name:'支付成功'},
    { path: 'payFailed',component:_import("pay/payFailed"),name:'支付失败'},

    { path: 'CollectionOrderList',component:_import("pay/CollectionOrderList"),name:'K3收款单List',meta:{ keepAlive:true }},
    { path: 'CollectionOrderInfo',component:_import("pay/CollectionOrderInfo"),name:'K3收款单Info'},
    { path: 'CollectionOrderAdd',component:_import("pay/CollectionOrderAdd"),name:'核销新增'},
    { path: 'ReceivebillHxAdd',component:_import("pay/ReceivebillHxAdd"),name:'核销新增-新'},
    { path: 'PayReceivebillHx',component:_import("pay/PayReceivebillHx"),name:'核销详情'},
    { path: 'ReceivebillHxInfo',component:_import("pay/ReceivebillHxInfo"),name:'核销详情-新'},
    { path: 'CollectionOrderEdit',component:_import("pay/CollectionOrderEdit"),name:'核销修改'},
    { path: 'ReceivebillHxEdit',component:_import("pay/ReceivebillHxEdit"),name:'核销修改-新'},
    { path: 'HXList',component:_import("pay/HXList"),name:'核销列表',meta:{ keepAlive:true }},

  ]
}




// WEBPACK FOOTER //
// ./src/router/pay.js